<div role="button" tabindex="0" on:click on:keypress class="cursor-pointer">
	<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="icon-link">
			<g id="Group 2">
				<path
					id="Vector (Stroke)"
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M3.7173 6.7112C4.17659 6.25192 4.79951 5.9939 5.44903 5.9939H10.7442C11.2612 5.9939 11.6803 6.41301 11.6803 6.93001C11.6803 7.44701 11.2612 7.86613 10.7442 7.86613H5.44903C5.29605 7.86613 5.14934 7.9269 5.04117 8.03507C4.933 8.14324 4.87223 8.28995 4.87223 8.44293V19.0333C4.87223 19.1863 4.933 19.333 5.04117 19.4412C5.14934 19.5494 5.29605 19.6101 5.44903 19.6101H16.0394C16.1924 19.6101 16.3391 19.5494 16.4473 19.4412C16.5555 19.333 16.6162 19.1863 16.6162 19.0333V13.7381C16.6162 13.2211 17.0353 12.802 17.5523 12.802C18.0693 12.802 18.4885 13.2211 18.4885 13.7381V19.0333C18.4885 19.6829 18.2304 20.3058 17.7712 20.7651C17.3119 21.2243 16.689 21.4824 16.0394 21.4824H5.44903C4.79951 21.4824 4.17659 21.2243 3.7173 20.7651C3.25802 20.3058 3 19.6829 3 19.0333V8.44293C3 7.7934 3.25802 7.17048 3.7173 6.7112Z"
					fill="#6B6B6B"
				/>
				<path
					id="Vector (Stroke)_2"
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M19.667 3.89654C20.184 3.89654 20.6031 4.31565 20.6031 4.83266L20.6031 10.8502C20.6031 11.3672 20.184 11.7864 19.667 11.7864C19.15 11.7864 18.7309 11.3672 18.7309 10.8502L18.7309 5.76877L13.6494 5.76877C13.1324 5.76877 12.7133 5.34966 12.7133 4.83266C12.7133 4.31565 13.1324 3.89654 13.6494 3.89654H19.667Z"
					fill="#6B6B6B"
				/>
				<path
					id="Vector (Stroke)_3"
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M20.3289 4.17072C20.6945 4.5363 20.6945 5.12901 20.3289 5.49459L13.1078 12.7157C12.7423 13.0813 12.1495 13.0813 11.784 12.7157C11.4184 12.3501 11.4184 11.7574 11.784 11.3918L19.0051 4.17072C19.3706 3.80515 19.9633 3.80515 20.3289 4.17072Z"
					fill="#6B6B6B"
				/>
			</g>
		</g>
	</svg>
</div>
